<!--
  Mobile layout for this page. The split into Raw Materials / Products (spec §1)
  applies to both layouts — this is the same screen, just rendered for phones —
  so the mobile view is pinned to this page's domain instead of following the
  old shared raw/products tab.
-->
<app-mobile-inventory-view
  class="d-md-none"
  lockedTab="products"
  [totalFinishedGoods]="totalFinishedGoods"
  [totalProductValueFromBOM]="totalProductValueFromBOM"
  [filteredFinishedGoods]="filteredFinishedGoods"
  [categories]="categories"
  [unitsOfMeasure]="uomList"
  [suppliers]="suppliers"
  [stackedBarData]="stackedBarData"
  [baseColors]="baseColors"
  [categoryLabels]="categoryLabels"
  [categoryData]="categoryData"
  (saveItemMobile)="saveItemMobile($event)"
  (deleteItemMobile)="deleteItemMobile($event)"
  (downloadFinishedTemplateMobile)="downloadFinishedGoodTemplate()"
  (importMobile)="onFileSelected($event)"
  (createCategoryMobile)="createCategoryMobile($event)"
></app-mobile-inventory-view>

<div class="container-fluid">
  <div class="welcome-section mb-4 fade-in d-none d-md-block">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Products</h2>
        <h4 class="welcome-text">Check your product stock levels and manage them</h4>
      </div>
      <div class="text-end">
        <small class="text-muted d-block">Current User:</small>
        <h6 class="mb-0">{{fullName}}</h6>
        <small class="text-muted d-block">{{tenantName}}</small>
      </div>
    </div>
  </div>

  <div class="dashboard-cards fade-in d-none d-md-flex">
    <div class="metric-card main" style="width: 50%;">
      <div class="card-content">
        <div class="icon-container main">
          <i class="bi bi-box-seam" style="font-size: 1.5rem; color: #007A8F;"></i>
        </div>
        <div class="metric-info">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center gap-2 mb-2">
              <p class="metric-label">Total Products</p>
            </div>
            <span class="fw-bold text-center" style="font-size: 1.4rem;">{{ totalFinishedGoods }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="metric-card success">
      <div class="card-content">
        <div class="icon-container success">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15V17M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="#B0213C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10C14.5 11.3807 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3807 9.5 10Z"
              stroke="#B0213C" stroke-width="2" />
          </svg>
        </div>
        <div class="metric-info">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center gap-2 mb-2">
              <p class="metric-label">Total Product Value</p>
            </div>
            <span class="fw-bold text-center" style="font-size: 1.4rem;">
              {{ totalProductValueFromBOM | currency:'ZAR':'symbol':'1.2-2' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-cards fade-in">
    <div class="metric-card inv-products-section" style="flex-grow: 1; max-height: 120vh; display: flex; flex-direction: column">
      <div class="card-body" style="display: flex; flex-direction: column; flex: 1; min-height: 0">
        <div class="CardHeader">
          <div class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-bag-check"></i>
            </div>
            <span style="display: flex; align-items: center;">
              <h3 style="margin-bottom: 5px;">Products</h3>
              <app-tooltip [tooltipId]="'stock-goods'">
                <i icon class="bi bi-info-circle"></i>
                <div content>
                  <p>
                    <strong>
                      Products are things that are made or offered to people to buy or use. They can be physical items
                      you can touch or services that you do for someone.
                    </strong>
                  </p>
                </div>
              </app-tooltip>
            </span>
          </div>
          <div role="group" aria-label="Product Actions" style="display: flex; align-items: center; gap: 4px;">
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text" (click)="downloadFinishedGoodTemplate()"
              [disabled]="isImporting">
              <i class="bi bi-download"></i>
              Download Template
            </button>

            <input #fileInput type="file" accept=".xlsx" (change)="onFileSelected($event)" hidden>

            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="fileInput.click()"
              [disabled]="isImporting">
              <i class="bi bi-upload"></i>
              Import
            </button>

            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="handleFinishedClick()">
              <i class="bi bi-plus"></i>
              Add
            </button>

            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="handleServiceClick()">
              <i class="bi bi-plus"></i>
              Service
            </button>
          </div>
        </div>

        <div class="inv-toolbar d-flex align-items-center gap-2 mb-3 flex-wrap" style="padding-top: 5px;">
          <div class="input-group" style="max-width: 75%; flex: 1 1 220px;">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control" placeholder="Search Products..."
              [(ngModel)]="finishedGoodsSearchTerm" (input)="filterFinishedGoods()" />
          </div>

          <div class="btn-group segmented" role="group" aria-label="Product type filter">
            <input type="radio" class="btn-check" name="productType" id="product-type-all" autocomplete="off"
                   [checked]="productTypeFilter === 'all'"
                   (change)="productTypeFilter = 'all'; filterFinishedGoods()">
            <label class="btn segmented-btn"
                   [class.btn-teal-gradient]="productTypeFilter === 'all'"
                   [class.btn-grey-gradient]="productTypeFilter !== 'all'"
                   for="product-type-all">
              <i class="bi bi-collection me-1"></i> All
            </label>

            <input type="radio" class="btn-check" name="productType" id="product-type-physical" autocomplete="off"
                   [checked]="productTypeFilter === 'physical'"
                   (change)="productTypeFilter = 'physical'; filterFinishedGoods()">
            <label class="btn segmented-btn"
                   [class.btn-teal-gradient]="productTypeFilter === 'physical'"
                   [class.btn-grey-gradient]="productTypeFilter !== 'physical'"
                   for="product-type-physical">
              <i class="bi bi-box-seam me-1"></i> Physical
            </label>

            <input type="radio" class="btn-check" name="productType" id="product-type-service" autocomplete="off"
                   [checked]="productTypeFilter === 'service'"
                   (change)="productTypeFilter = 'service'; filterFinishedGoods()">
            <label class="btn segmented-btn"
                   [class.btn-teal-gradient]="productTypeFilter === 'service'"
                   [class.btn-grey-gradient]="productTypeFilter !== 'service'"
                   for="product-type-service">
              <i class="bi bi-gear me-1"></i> Service
            </label>
          </div>

          <div class="filter-button-container">
            <button class="btn btn-teal-gradient btn-sm" [class.btn-teal-gradient]="!isFilterPanelOpenFinishedGoods"
              [class.btn-grey-gradient]="isFilterPanelOpenFinishedGoods" type="button"
              (click)="toggleFilterPanelFinishedGoods()">
              <i class="bi bi-funnel"></i>
              {{ !isFilterPanelOpenFinishedGoods ? 'Show Filters' : 'Hide Filters' }}
            </button>
          </div>
        </div>

        <div class="filter-panel-container">
          <div class="filter-panel" [class.visible]="isFilterPanelOpenFinishedGoods">
            <div class="d-flex align-items-center">
              <select class="form-select form-select-sm" [(ngModel)]="selectedCategoryFilter"
                (change)="filterFinishedGoods()">
                <option [ngValue]="null">All Categories</option>
                <option *ngFor="let category of categories" [ngValue]="category.categoryId">
                  {{ category.categoryName }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center gap-2 w-100">
                <span class="text-muted me-2">Stock</span>
                <div class="btn-group segmented" role="group" aria-label="Finished goods stock filter">
                  <input type="radio" class="btn-check" name="fgStock" id="fg-stock-all" autocomplete="off"
                         [checked]="!NoProductStock && !WithProductStock"
                         (change)="NoProductStock=false; WithProductStock=false; filterFinishedGoods()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="!NoProductStock && !WithProductStock"
                         [class.btn-grey-gradient]="NoProductStock || WithProductStock"
                         for="fg-stock-all">
                    <i class="bi bi-collection me-1"></i> All
                  </label>

                  <input type="radio" class="btn-check" name="fgStock" id="fg-stock-low" autocomplete="off"
                         [checked]="NoProductStock && !WithProductStock"
                         (change)="NoProductStock=true; WithProductStock=false; filterFinishedGoods()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="NoProductStock && !WithProductStock"
                         [class.btn-grey-gradient]="!NoProductStock || WithProductStock"
                         for="fg-stock-low">
                    <i class="bi bi-exclamation-triangle me-1"></i> Low
                  </label>

                  <input type="radio" class="btn-check" name="fgStock" id="fg-stock-in" autocomplete="off"
                         [checked]="!NoProductStock && WithProductStock"
                         (change)="NoProductStock=false; WithProductStock=true; filterFinishedGoods()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="!NoProductStock && WithProductStock"
                         [class.btn-grey-gradient]="NoProductStock || !WithProductStock"
                         for="fg-stock-in">
                    <i class="bi bi-check-circle me-1"></i> In stock
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-2">
              <div class="d-flex align-items-center gap-2 w-100 justify-content-end">
                <span class="text-muted me-1">Rows per page</span>
                <select class="form-select form-select-sm" style="max-width: 90px"
                        [(ngModel)]="finishedGoodsPageSize"
                        (ngModelChange)="finishedGoodsCurrentPage = 1">
                  <option [ngValue]="15">15</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive scrollable-content" style="flex-grow: 1; min-height: 0; overflow-y: auto">
          <div *ngIf="filteredFinishedGoods.length === 0" class="empty-state p-4 text-center">
            <div class="empty-state-icon mb-3">
              <i class="bi bi-bag-check" style="font-size: 2.5rem; color: #6c757d;"></i>
            </div>
            <h5 class="mb-2">No Products Found</h5>
            <p class="text-muted mb-0">Add your first Products to get started</p>
            <button class="btn btn-primary mt-3" (click)="handleFinishedClick()">
              <i class="bi bi-plus-circle me-1"></i> Add Products
            </button>
          </div>

          <table class="table table-hover align-middle mb-0 d-none d-md-table" *ngIf="filteredFinishedGoods.length > 0">
            <thead class="table-header">
              <tr>
                <th class="fw-bold" style="cursor: pointer" (click)="sortFinishedBy('itemCode')">
                  SKU
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': finishedSortColumn !== 'itemCode' || (finishedSortColumn === 'itemCode' && finishedSortDirection === 'desc'),
                        'bi-caret-up-fill': finishedSortColumn === 'itemCode' && finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortFinishedBy('itemName')">
                  Item Name
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': finishedSortColumn !== 'itemName' || (finishedSortColumn === 'itemName' && finishedSortDirection === 'desc'),
                        'bi-caret-up-fill': finishedSortColumn === 'itemName' && finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortFinishedBy('CategoryName')">
                  Category
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': finishedSortColumn !== 'CategoryName' || (finishedSortColumn === 'CategoryName' && finishedSortDirection === 'desc'),
                        'bi-caret-up-fill': finishedSortColumn === 'CategoryName' && finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: default" class="fw-bold">Quantity</th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortFinishedBy('sellingPrice')">
                  Selling Price
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill': finishedSortColumn !== 'sellingPrice' || (finishedSortColumn === 'sellingPrice' && finishedSortDirection === 'desc'),
                        'bi-caret-up-fill': finishedSortColumn === 'sellingPrice' && finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th *ngIf="userRole === 'Admin User'" style="cursor: default" class="fw-bold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of finishedGoodsPaged">
                <td>{{ item.itemCode }}</td>
                <td class="fw-semibold">
                  {{ item.itemName }}
                  <!-- Spec §2: Physical product vs Service is a real distinction, so show it. -->
                  <span class="type-badge" [class.type-badge--service]="item.itemTypeID === 4">
                    {{ item.itemTypeID === 4 ? 'Service' : 'Physical' }}
                  </span>
                </td>
                <td>
                  <span class="category-badge" [style.background-color]="getCategoryColor(item.CategoryName)">
                    {{ item.CategoryName }}
                  </span>
                </td>
                <td>
                  <!-- A Service holds no stock; it is quantified as the time it
                       takes, so show that rather than a misleading stock count. -->
                  <span *ngIf="item.itemTypeID === 4; else productQty" class="quantity-badge badge-neutral">
                    {{ item.purchaseQuantity || 0 }} min
                  </span>
                  <ng-template #productQty>
                    <span class="quantity-badge badge-neutral">
                      {{ item.quantity }}
                    </span>
                  </ng-template>
                </td>
                <td>{{ item.sellingPrice | currency : "ZAR" }}</td>
                <td *ngIf="userRole === 'Admin User'" class="text-nowrap">
                  <button *ngIf="canSellItem(item)" class="btn-outline-primary" title="Sell" (click)="openSell(item)">
                    <i class="bi bi-cart-check"></i>
                  </button>
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary" (click)="editItem(item)">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary danger"
                    (click)="selectedItem = item; showDeleteModal = true">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <nav *ngIf="filteredFinishedGoods.length > 0" class="mt-2" aria-label="Products pagination">
          <ul class="pagination pagination-sm mb-0 justify-content-end">
            <li class="page-item" [class.disabled]="finishedGoodsCurrentPage === 1">
              <button class="page-link" type="button" (click)="changeFinishedGoodsPage(finishedGoodsCurrentPage - 1)" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </button>
            </li>
            <li class="page-item" *ngFor="let page of finishedGoodsPages" [class.active]="page === finishedGoodsCurrentPage">
              <button class="page-link" type="button" (click)="changeFinishedGoodsPage(page)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="finishedGoodsCurrentPage === finishedGoodsTotalPages">
              <button class="page-link" type="button" (click)="changeFinishedGoodsPage(finishedGoodsCurrentPage + 1)" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <div class="dashboard-cards fade-in d-none d-md-flex">
    <div class="chart-container metric-card chart-40" style="min-height: 80vh;height: calc(100% - 40px);">
      <app-pie-chart *ngIf="categoryLabels.length > 0 && categoryData.length > 0" [labels]="categoryLabels"
        [data]="categoryData" [title]="'Product Stock Distribution by Category'" [colors]="baseColors" [ItemsPerPage]="5">
      </app-pie-chart>
      <div *ngIf="categoryLabels.length === 0 || categoryData.length === 0"
        class="d-flex align-items-center justify-content-center h-100">
        <div class="text-center p-4">
          <i class="bi bi-pie-chart fs-1 text-muted mb-2"></i>
          <p class="mb-0">No data available for the pie chart</p>
          <small class="text-muted">Add products with categories to see the distribution</small>
        </div>
      </div>
    </div>

    <div class="metric-card chart-60">
      <div class="chart-container" style="height: calc(100% - 40px);">
        <div *ngIf="stackedBarData && stackedBarData.labels && stackedBarData.labels.length > 0; else noBarData" class="h-100">
          <app-reuseable-bar-chart
            [title]="'Product Stock Value by Category'"
            [labels]="stackedBarData.labels"
            [data]="stackedBarData.datasets[0].data"
            [colors]="baseColors"
            [ItemsPerPage]="ItemsPerPage"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [totalItemsCount]="totalItemsCount"
            [goToPage]="goToPage"
            [pageSizeChange]="onPageSizeChange"
            (pageChange)="onPageChange($event)">
          </app-reuseable-bar-chart>
        </div>

        <ng-template #noBarData>
          <div class="d-flex align-items-center justify-content-center h-100">
            <div class="text-center p-4">
              <i class="bi bi-bar-chart fs-1 text-muted mb-2"></i>
              <p class="mb-0">No data available for the bar chart</p>
              <small class="text-muted">Add products with categories to see the distribution</small>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="d-none d-md-block">
  <app-alert
    [visible]="isAlertVisible"
    [title]="alertTitle"
    [message]="alertMessage"
    [alertbgcolor]="alertBgColor"
    [alerttextcolor]="alerttextcolor"
    (closed)="isAlertVisible = false">
  </app-alert>
</div>

<app-inventory-item-modal
  [visible]="showAddModal"
  [isEditing]="isEditing"
  [isFinishedGood]="true"
  [isServiceItem]="isServiceItem"
  [isAddingQuantity]="false"
  [showPurchaseFields]="showPurchaseFields"
  [inventoryForm]="inventoryForm"
  [supplierForm]="supplierForm"
  [categoryForm]="categoryForm"
  [isCreatingSupplier]="isCreatingSupplier"
  (isCreatingSupplierChange)="isCreatingSupplier = $event"
  [isCreatingCategory]="isCreatingCategory"
  (isCreatingCategoryChange)="isCreatingCategory = $event"
  [selectedSupplier]="selectedSupplier"
  [selectedCategory]="selectedCategory"
  [supplierOptions]="desktopSupplierOptions"
  [categoryOptions]="desktopCategoryOptions"
  [uomList]="uomList"
  (save)="saveItem()"
  (cancel)="closeAddModal()"
  (quickClose)="showAddModal = false; inventoryForm.reset(); supplierForm.reset(); categoryForm.reset();"
  (createSupplierClick)="createSupplier()"
  (createCategoryClick)="createCategory()"
  (navigateToAddSupplierClick)="navigateToAddSupplier()"
  (togglePurchaseFieldsClick)="togglePurchaseFields()"
  (supplierSelected)="onDesktopSupplierSelected($event)"
  (categorySelected)="onDesktopCategorySelected($event)"
  (quantityToAddChange)="setQuantityToAdd($event)">
</app-inventory-item-modal>

<div class="modal fade" id="importProgressModalProducts" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
  [class.show]="isImporting" [style.display]="isImporting ? 'block' : 'none'" [attr.aria-hidden]="!isImporting">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-upload me-2"></i>
          Importing Items
        </h5>
      </div>
      <div class="modal-body p-4">
        <div class="d-flex justify-content-center mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <h6 class="text-center mb-3">Processing your import...</h6>
        <div class="progress mb-4" style="height: 10px; border-radius: 5px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
            [style.width]="importProgress + '%'" [attr.aria-valuenow]="importProgress" aria-valuemin="0" aria-valuemax="100">
            <span class="visually-hidden">{{ importProgress }}% Complete</span>
          </div>
        </div>
        <div class="d-flex justify-content-between mb-2">
          <small class="text-muted">Progress</small>
          <small class="fw-bold">{{ importProgress }}%</small>
        </div>
        <div class="text-center mt-4">
          <p class="small text-muted mb-0">
            <i class="bi bi-info-circle me-1"></i>
            Please do not close this window while the import is in progress.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="errorDetailsModalProducts" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Import Results
        </h5>
        <button type="button" class="close-button" data-bs-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body p-4">
        <div *ngIf="importResults.errors.length > 0" class="mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">
              <i class="bi bi-exclamation-triangle text-warning me-2"></i>
              Import Issues ({{ importResults.errors.length }})
            </h6>
            <span>
              <span *ngIf="errorCount() > 0" class="badge bg-danger me-1">{{ errorCount() }} error{{ errorCount() !== 1 ? 's' : '' }}</span>
              <span *ngIf="warningCount() > 0" class="badge bg-warning text-dark">{{ warningCount() }} need{{ warningCount() === 1 ? 's' : '' }} review</span>
            </span>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th style="width: 5rem;">Row</th>
                  <th class="w-25">Item</th>
                  <th style="width: 8rem;">Value</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of importResults.errors; let i = index" [attr.data-testid]="'error-row-' + i"
                  class="border-start border-4"
                  [class.border-danger]="error.severity !== 'warning'"
                  [class.border-warning]="error.severity === 'warning'">
                  <td class="text-muted">{{ error.rowNumber || error.rowIndex }}</td>
                  <td class="fw-semibold">
                    <div class="d-flex align-items-center">
                      <i class="bi me-2"
                        [class.bi-x-circle-fill]="error.severity !== 'warning'"
                        [class.text-danger]="error.severity !== 'warning'"
                        [class.bi-exclamation-triangle-fill]="error.severity === 'warning'"
                        [class.text-warning]="error.severity === 'warning'"></i>
                      {{ error.item['itemname*'] || error.itemName || 'Unknown Item' }}
                    </div>
                  </td>
                  <td>
                    <code *ngIf="error.rawValue">{{ error.rawValue }}</code>
                  </td>
                  <td>
                    <span class="badge bg-opacity-10"
                      [class.bg-danger]="error.severity !== 'warning'"
                      [class.bg-warning]="error.severity === 'warning'"
                      [style.color]="error.severity === 'warning' ? '#000' : '#fff'">
                      {{ error.error }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button *ngIf="hasFinishedGoodErrors()" type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="downloadFailedFinishedGoods()">
          <i class="bi bi-download"></i> Download Failed Products
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showDeleteModal && selectedItem" class="modal-backdrop" (click)="showDeleteModal = false">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Delete Stock / Goods</h2>
      <button type="button" class="close-button" (click)="showDeleteModal = false">x</button>
    </div>
    <div class="modal-body">
      <p>Are you sure you want to delete this stock / goods item?</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="showDeleteModal = false">Cancel</button>
      <button class="btn btn-danger" (click)="selectedItem && deleteItem(selectedItem)">Delete</button>
    </div>
  </div>
</div>

<div *ngIf="showSellModal && sellItem" class="modal-backdrop" (click)="closeSellModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Sell {{ sellItem.itemName }}</h2>
      <button type="button" class="close-button" (click)="closeSellModal()">x</button>
    </div>
    <div class="modal-body">
      <div *ngIf="isLoadingSellAvailability" class="text-center py-3">
        <div class="app-loading-spinner"></div>
      </div>

      <ng-container *ngIf="!isLoadingSellAvailability">
        <p class="mb-2">
          <strong>{{ sellAvailable }}</strong> unit(s) available to sell from completed production.
        </p>

        <div class="mb-3">
          <label class="form-label" for="sellQuantityInput">Quantity to sell</label>
          <input id="sellQuantityInput" type="number" class="form-control" min="1" [(ngModel)]="sellQuantity" />
        </div>

        <div *ngIf="sellShortfall === 0" class="d-flex gap-2">
          <button class="btn btn-teal-gradient" [disabled]="isSelling || sellQuantity <= 0" (click)="confirmSell()">
            {{ isSelling ? 'Selling…' : 'Sell' }}
          </button>
          <button class="btn btn-secondary" (click)="closeSellModal()">Cancel</button>
        </div>

        <div *ngIf="sellShortfall > 0">
          <p class="text-warning mb-2">
            Only {{ sellAvailable }} available. Manufacture {{ sellShortfall }} more?
          </p>
          <div class="d-flex gap-2">
            <button *ngIf="sellAvailable > 0" class="btn btn-teal-gradient" [disabled]="isSelling" (click)="confirmSell()">
              {{ isSelling ? 'Selling…' : 'Sell ' + sellAvailable + ' now' }}
            </button>
            <button class="btn btn-grey-gradient" (click)="goManufacture()">
              Manufacture {{ sellShortfall }}
            </button>
            <button class="btn btn-secondary" (click)="closeSellModal()">Cancel</button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="app-spinner-overlay">
  <div class="app-loading-spinner"></div>
</div>
